import { WCalParentModelType } from '@teinor/erp/types/company/WCalParent'
import { useLocation } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, CustomRenderDisplayHoursByMins, DeleteRow, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateWorkingCalendar from './ModalCreateWorkingCalendar'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import ModalChangeActiveWCal from './ModalChangeActiveWCal'

interface WorkingCalendarsProps extends ComponentWithPermissions { }

const WorkingCalendars: React.FC<WorkingCalendarsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('WorkingCalendars', 'Calendarios laborales'),
        newText: t('newWorkingCalendar', 'Nuevo Calendario laboral'),
    }

    return (
        <BaseScreenTable TableComponent={TableWorkingCalendars} CreateModalComponent={ModalCreateWorkingCalendar} pageData={pageData} userPermissions={userPermissions} DeleteModalComponent={ModalChangeActiveWCal}/>
    )
}

type TableWorkingCalendarsProps = TableComponentProps & {}


interface WCalParentModelTypeExt extends WCalParentModelType { 
    dayMins: number
    marginStartMin: number
    marginEndMin: number
 }
const TableWorkingCalendars: React.FC<TableWorkingCalendarsProps> = ({ setTableInstance, setOpened, userPermissions}) => {
    const { t } = useTwinTranslation()
    const location = useLocation().pathname
    const columns: ColumnTableSchema<WCalParentModelTypeExt> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 70
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
        },
        {
            id: 'dayMins',
            dataKey: 'dayMins',
            label: t('dayHours','Horas al día'),
            minWidth: 140,
            customRender: (_parameterValue, allRowData) => <CustomRenderDisplayHoursByMins value={allRowData?.WCals?.[0].dayMins} />,
            sortable: true,
        },
        {
            id: 'marginStartMin',
            dataKey: 'marginStartMin',
            minWidth: 160,
            customRender: (_parameterValue, allRowData) => <CustomRenderDisplayHoursByMins value={allRowData?.WCals?.[0].marginStartMin} />,
            label: t('marginStart', 'Margen para empezar'),
        },
        {
            id: 'marginEndMin',
            dataKey: 'marginEndMin',
            minWidth: 160,
            customRender: (_parameterValue, allRowData) => <CustomRenderDisplayHoursByMins value={allRowData?.WCals?.[0].marginEndMin} />,
            label: t('marginEnd', 'Margen para acabar'),
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: {
                    items: {
                        'true': { name: t('actived', 'Activados') },
                        'false': { name: t('disabled', 'Desactivados') },
                        'all': { name: t('all', 'Todos') }
                    },
                    label: t('active', 'Activo')
                }
            },
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} icon={!allRowData?.active ? faRotateLeft : undefined} messageTooltip={!allRowData?.active ? t('reactivate', 'Reactivar') : undefined} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[location, ['$WCalId', 'main']]} name='WorkingCalendars' columns={columns} getDataFrom='/api/app/workingCalendar/getAllWorkingCalendarParents' onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} />
    )
}


export default WorkingCalendars